module.exports = __webpack_public_path__ + "static/media/Linkedpro.8d9068ab.jpg";